import { render, staticRenderFns } from "./componentNav.vue?vue&type=template&id=ccea673a&scoped=true"
import script from "./componentNav.vue?vue&type=script&lang=js"
export * from "./componentNav.vue?vue&type=script&lang=js"
import style0 from "./componentNav.vue?vue&type=style&index=0&id=ccea673a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccea673a",
  null
  
)

export default component.exports